import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import withTheme from "@mui/styles/withTheme";
import ReactPlayer from "react-player";
import { animated } from "react-spring";
import styled from "styled-components";
import Color from "../../../assets/colors";

// Typography Components //
export const FilterSubtitle = styling(Typography)((props) => ({
  color: Color.white,
  display: "inline-block",
  alignSelf: "center",
  fontSize: "24px",
  fontWeight: "400",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "20px",
  },

  [props.theme.breakpoints.down(768)]: {
    fontSize: "14px",
  },
}));

// Grid Components //
export const GridFilters = styling(Grid)((props) => ({
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  position: "absolute",
  top: 0,
  width: "100%",
  height: "100%",
  padding: "30px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",

  [props.theme.breakpoints.down(480)]: {
    padding: "10px",
  },
}));

export const GridFilterContainer = styling(Grid)({
  width: "79%",
  maxWidth: "960px",
  minWidth: "300px",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
  display: "flex",
});

export const GridTitle = styling(Grid)({
  textAlign: "center",
});

export const GridContainer = styling(Grid)({
  display: "flex",
  flexDirection: "row",
  marginTop: "10px",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
});

export const GridContainerInner = styling(Grid)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "baseline",
  height: "42px",
  marginTop: "15px",
});

export const TextFieldContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "baseline",
  maxWidth: "240px",

  [props.theme.breakpoints.down("sm")]: {
    maxWidth: "280px",
    display: "flex",
    justifyContent: "center",
  },
}));

export const GridCompanyLogo = styling(Grid)((props) => ({
  position: "absolute",
  bottom: "15px",
  right: "25px",
  display: "flex",
  justifyContent: "flex-end",
  flexDirection: "column",
  alignItems: "center",

  [props.theme.breakpoints.down(480)]: {
    alignItems: "flex-end",
    bottom: "15px",
    right: "40%",
  },
}));

export const GridLogoContainer = styling(Grid)({
  cursor: "pointer",
  width: "72px",
  height: "72px",
});

export const GridPlayButtonContainer = styling(Grid)((props) => ({
  height: "35px",
  marginTop: "0.75rem",

  [props.theme.breakpoints.down(480)]: {
    height: "0px",
  },
}));

export const ButtonGrid = styling(Grid)((props) => ({
  [props.theme.breakpoints.down(780)]: {
    marginTop: "20px",
  },
}));

// Misc. Components //
export const ContainerStyled = styling("div")({
  position: "relative",
  margin: "40px 8.7% 40px 8.7%",
});

export const IconButtonStyled = styling(IconButton)((props) => ({
  color: Color.white,
  padding: "5px",

  "&:hover": {
    backgroundColor: Color.black,
  },

  [props.theme.breakpoints.down(480)]: {
    display: "none",
  },
}));

export const ReactPlayerStyled = styling(ReactPlayer)((props) => ({
  objectFit: "cover",

  [props.theme.breakpoints.down(780)]: {
    height: "55vh !important",
  },

  [props.theme.breakpoints.down(480)]: {
    height: "640px !important",
  },
}));

export const ImageStyled = styling("img")({
  backgroundColor: Color.white,
  borderRadius: "10px",
  objectFit: "scale-down",
  width: "100%",
  height: "100%",
});

export const TextFieldStyled = styling(TextField)({
  color: Color.white,
  marginLeft: "12px",
  width: "35%",
  minWidth: "200px",

  input: {
    textAlign: "center",
    color: Color.white,
    fontSize: "1.6rem",
  },

  label: {
    color: Color.white,
    fontSize: "1.6rem",
  },

  "& ::placeholder": {
    color: Color.white,
    opacity: 1,
  },

  "& .MuiInputBase-input:focus::placeholder": {
    color: "transparent",
  },

  "  & .MuiInputBase-input": {
    borderColor: `${Color.white} !important`,
  },

  "& .MuiInput-underline::before": {
    borderColor: `${Color.white} !important`,
  },

  "& .MuiInput-underline:hover:before": {
    borderColor: `${Color.white} !important`,
  },

  "& .MuiInput-underline::after": {
    borderColor: `${Color.white} !important`,
  },
});

export const TitleStyled = withTheme(styled(animated(Typography))`
  && {
    text-transform: uppercase;
    color: ${Color.white};
    font-weight: bold;
    font-family: "Poppins", sans-serif;
    line-height: 1.25em;
    margin-bottom: 1rem;
    font-size: 3.8rem;

    ${(props) => props.theme.breakpoints.down("lg")} {
      font-size: 2.4rem;
    }

    ${(props) => props.theme.breakpoints.down(768)} {
      font-size: 1.8rem;
    }
  }
`);
